
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const NameAnalysisRenewOverTimePage = lazy(() => import('./NameAnalysisRenewOverTimePage'));
const path = 'reports/subword-frequency/renew-over-time';
const NameAnalysisRenewOverTimeRoute: FuseRouteItemType = {
	path: path,
	element: <NameAnalysisRenewOverTimePage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Name Analysis For Renew Over Time',
					helpName: 'Name Analysis For Renew Over Time',
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default NameAnalysisRenewOverTimeRoute;
